import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class TouchService {

  public isTouch = true;

  constructor(
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.document.ontouchstart = this.onTouchStart;
    this.document.ontouchmove = this.onTouchMove;
  }

  onTouchStart = () => {
    this.isTouch = true;
  }

  onTouchMove = () => {
    this.isTouch = false;
  }

  getIsDragging() {
    return this.isTouch;
  }
}
